export default {
    chipContainer: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    selectableChipContainer: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
        '&:hover': {
            backgroundColor: '#c3c3c3'
        }
    },
    chipText: {
        padding: '0 12px',
    },
}